import { forwardRef, LegacyRef, MouseEventHandler } from 'react';
import styled from '@emotion/styled';

type Props = {
  children: React.ReactNode;
  onClick?: MouseEventHandler;
};

const VerticalFlex = ({ children, onClick, ...props }: Props, ref: LegacyRef<HTMLDivElement>) => (
  <LayoutRoot onClick={onClick} {...props} ref={ref}>
    {children}
  </LayoutRoot>
);

export default forwardRef(VerticalFlex);

const LayoutRoot = styled.div`
  display: flex;
  flex-direction: column;
`;
